import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import { LINK_RCS_GUIDE } from 'shared/constants/links'
import { uiStore } from 'shared/store/uiStore'
import { RcsPath } from 'pages/settings/pages/rcs/route/rcsPath'
import { useRcsContext } from '../../context/rcsContext'

import styles from './styles.module.scss'

export const CreateRcsButton = observer(() => {
  const {} = useRcsContext()

  const handleCreate = () => {
    uiStore.changeRoute({
      path: RcsPath.create,
    })
  }

  return (
    <Button
      text='New RCS sender'
      size='medium'
      iconProps={{ icon: 'add' }}
      onClick={handleCreate}
      className={styles.createButton}
    />
  )
})

export const GuideRcsButton = observer(({ className }: { className?: string }) => (
  <Button
    className={className}
    tag={'a'}
    href={LINK_RCS_GUIDE}
    text='Help guide'
    target='_blank'
    rel='noreferrer'
    size='medium'
    contained='secondary'
    iconProps={{ icon: 'info' }}
  />
))
